const en = {
  nav: {
    services: 'Services',
    amazonPPC: 'Amazon PPC',
    produktbilder: 'Product Images',
    amazonSEO: 'Amazon SEO',
    designPortfolio: 'Design Portfolio',
    customerSuccess: 'Client Success Stories',
    contact: 'Contact',
  },

  hero: {
    tagline: 'Amazon Experts from Germany',
    title: 'Scale your Amazon PPC in just 90 days –',
    titleHighlight: 'with up to 80% more profit',
    titleEnd: '!',
    bullets: [
      'No internal resources required!',
      'Approx. 20 hours saved per week for your team',
      'Typically 2-4x ROI on our services – measured by seller profit',
    ],
    ratingScore: '5.0',
    videoCaption: 'Customer feedback from',
    videoCaptionName: 'Flavio Simonetti',
    ctaTitle: 'Free Account Analysis',
    ctaSub: 'We analyze your Amazon account and show you how to generate more revenue.',
    bulletsCta: '» Check Your Potential',
    advisorAlt: 'Advisor',
    minimize: 'Minimize',
    free: 'Free',
    play: 'Play',
    pause: 'Pause',
  },

  referencesBanner: {
    title: 'A Selection of Our Clients',
  },

  servicesBanner: {
    label: '15+ Years of Experience',
    title: 'Full-Service',
    titleHighlight: 'for Amazon Sellers',
    subtitle: 'As former Amazon sellers, we know what it takes to succeed on Amazon. That\'s why we offer you more than individual services – we deliver a',
    subtitleHighlight: 'complete package of performance, design and strategy',
    card1Pill: 'Amazon PPC Management',
    card1Title: 'Profit',
    card1TitleLight: 'over just Traffic',
    card1Desc: 'We manage your account as if it were our own – focusing on',
    card1DescBold: 'real profit, not just ACOS',
    card1DescEnd: '. Running our own Amazon brands since 2017, manual optimization, CEO-level support.',
    card2Pill: 'Creative Flatrate',
    card2TitleLight: 'Hundreds of Listings.',
    card2Title: 'One Flat Rate.',
    card2Desc: 'Creative flat rate for larger brands with scalable needs. We create based on real reviews and customer feedback',
    card2DescBold: 'the perfect graphic design following Amazon compliance',
    card2DescEnd: ' and build pain points from reviews directly into the images – available as a subscription for long-term growth.',
    card3Pill: 'Amazon SEO & Strategy',
    card3TitleLight: 'From Strategy to',
    card3Title: 'Launch',
    card3Desc: 'Individual Amazon strategy for sustainable growth. We combine SEO + PPC + Conversion and keep you compliant with Amazon Guidelines 2025 –',
    card3DescBold: 'maximum leverage without black hat',
    card3DescEnd: '.',
    cta: 'Free Account Analysis',
  },

  ppcSection: {
    label: 'Amazon PPC',
    title: 'Amazon',
    titleHighlight: 'PPC',
    tagline: 'Direct support. Real profit.',
    description: 'We work directly on your Amazon PPC. With our own',
    descriptionBold: 'seller experience since 2017',
    descriptionEnd: ', manual optimization and direct CEO-level support, we drive sustainable growth and real profit – no one-size-fits-all automation.',
    feature1Title: 'Seller Mindset',
    feature1Text: 'Your account treated as our own – we think like sellers.',
    feature2Title: 'Own Seller Experience',
    feature2Text: 'Running our own Amazon brands since 2017 – we know the seller\'s daily life.',
    feature3Title: 'Direct Support',
    feature3Text: 'CEO-level support, WhatsApp & regular calls.',
    feature4Title: 'No Automation',
    feature4Text: 'Manual work in the account, no tool automation.',
    feature5Title: 'Always on the Cutting Edge',
    feature5Text: 'New PPC features deployed immediately: Top of Search Placement Boost, Dayparting & more.',
    feature6Title: 'Focus on Profit',
    feature6Text: 'Total revenue & profit over ACOS optimization alone.',
    cta: 'Free Account Analysis',
    stat1Label: 'Own brands since',
    stat1Value: '2017',
    stat2Label: 'Managed ad spend',
    stat2Value: '250M+',
    stat3Label: 'Focus on',
    stat3Value: 'Profit',
  },

  productImages: {
    label: 'Creative Flat Rate',
    title: 'Amazon',
    titleHighlight: 'Product Images',
    tagline: 'Creative flat rate for larger brands.',
    description: 'For brands with a large number of products and scalable needs. We create the perfect graphic design following Amazon guidelines based on real reviews and customer feedback, and build the most important pain points directly into the images – available as a flat rate/subscription for long-term growth.',
    highlightsLabel: 'We combine:',
    highlight1: 'Rendering + Amazon Compliance',
    highlight2: 'Built from real reviews',
    highlight3: 'Conversion-optimized infographics',
    highlight4: 'Available as flat rate / subscription',
    sliderHint: 'Move slider to compare',
    beforeLabel: 'Before',
    afterLabel: 'After',
    cta: 'Request Flat Rate Now',
  },

  portfolioTeaser: {
    label: 'Design Portfolio',
    title: '100+ Projects.',
    titleHighlight: 'Our Design Portfolio',
    subtitle: 'Discover our work – from main images to A+ content. Find your industry and get inspired. We\'re here to bring your ideas to life.',
    ctaLink: 'View Portfolio',
    viewAll: 'View All Designs',
  },

  seoSection: {
    label: 'Amazon SEO',
    title: 'Amazon',
    titleHighlight: 'SEO',
    tagline: 'Perfectly positioned from day one.',
    description: 'Many sellers only optimize for the biggest keywords – that\'s a mistake. We combine SEO structure, PPC data, and conversion optimization to get the maximum out of your listing. We always keep you compliant with current Amazon Guidelines 2025.',
    feature1Title: 'More Than High-Volume Keywords',
    feature1Desc: 'Most sellers only optimize for the biggest keywords – and fight against maximum competition. We strategically find keywords with less competition that are much easier to rank for while still driving relevant traffic.',
    feature2Title: 'SEO + PPC + Conversion',
    feature2Desc: 'Ranking doesn\'t come from SEO alone. We combine SEO structure with PPC data, optimize click-through rate (CTR) and increase conversion rate – for a listing that performs on all levels.',
    feature3Title: 'Amazon Guidelines 2025',
    feature3Desc: 'Many sellers risk ranking penalties because they don\'t correctly implement current listing guidelines. We pay attention to details like no emojis, no unnecessary capitalization, no special character tricks, and no keyword duplication.',
    feature4Title: 'Maximum Leverage Without Risk',
    feature4Desc: 'We get the maximum out of your listing – clean, sustainable and without black-hat methods. This way you rank stably long-term, without risking future problems with Amazon.',
    cta: 'Request SEO Analysis Now',
  },

  linkedInPreview: {
    label: 'Follow Us',
    title: 'Connect with us on',
    titleHighlight: 'LinkedIn',
    subtitle: 'Insights, case studies and news from the Amazon world.',
    profileName: 'Wolfgang Niedecken',
    profileCompany: '(Fox Performance)',
    profileRole: 'Amazon PPC | 250M+ € managed ad spend since 2018 | Revenue growth & time savings through data-driven Amazon Advertising | Mastermind Host',
    location: 'Weinheim, Baden-Württemberg, Germany',
    followers: '12,024',
    followersLabel: 'Followers',
    connections: '500+',
    connectionsLabel: 'Connections',
    followBtn: 'Follow',
    messageBtn: 'Send Message',
    feedTitle: 'Recent Posts',
    post1Content: 'New case study: +127% revenue increase for our client in just 3 months through optimized Amazon PPC strategies.',
    post1Date: '2 days ago',
    post2Content: 'Amazon Advertising Update 2026: What do the new Sponsored Brands features mean for your brand?',
    post2Date: '5 days ago',
    seeAll: 'View All Posts',
  },

  statsSection: {
    label: 'Measurable Results',
    title: 'Numbers That Speak for Themselves',
    stat1Value: '+127%',
    stat1Label: 'Revenue Growth',
    stat1Desc: 'Average for our clients in the first year',
    stat2Value: '-34%',
    stat2Label: 'ACoS Reduction',
    stat2Desc: 'While simultaneously increasing visibility',
    stat3Value: '24h',
    stat3Label: 'Response Time',
    stat3Desc: 'Maximum wait time for account optimizations',
  },

  comparisonSection: {
    label: 'The Difference',
    title: 'Why Sellers Switch to Us',
    othersTitle: 'Typical Challenges with Agencies',
    others1: 'Changing contacts, no one knows your account',
    others2: 'Monthly reports without real insights',
    others3: 'Main goal: spend budget, profit doesn\'t matter',
    others4: 'Days without response to urgent questions',
    others5: 'Junior staff without Amazon experience',
    others6: 'Long contract terms, hidden costs',
    usTitle: 'Fox Performance',
    us1: 'Dedicated contact person',
    us1End: ' who knows your business',
    us2Start: 'Regular calls with',
    us2Bold: 'concrete action items',
    us3Bold: 'Profit-First:',
    us3End: ' Every decision must be profitable',
    us4Start: 'Max.',
    us4Bold: '48h response time',
    us4End: ', usually faster',
    us5Bold: '15+ years',
    us5End: ' of Amazon experience on the team',
    us6Start: 'Fair prices,',
    us6Bold: '6 & 12 month contracts',
  },

  caseStudies: {
    label: 'Case Studies',
    title: 'Real',
    titleHighlight: 'Results',
    subtitle: 'Success Stories from Our Clients',
    changesTitle: 'What was changed?',
    moreChanges: 'more measures',
    clickToEnlarge: 'Click to enlarge',
    closeLightbox: 'Close lightbox',
    case1Client: 'Aquaristikwelt24',
    case1Subtitle: 'Pool & Aquarium Supplies',
    case1Badge: '+457% Growth',
    case1Highlight: '€98,000 → €448,324 Ad Revenue',
    case1Desc: 'At takeover, the best months were at €98,000. With an optimized target ACoS, we scaled revenue to €448,324 – within profitability targets.',
    case2Client: 'McFilter',
    case2Subtitle: 'Vacuum Cleaner Accessories',
    case2Badge: 'ACoS -69%',
    case2Highlight: '26.64% → 8.17% ACoS with 5x more revenue',
    case2Desc: 'The account started with €74,964 ad revenue at an inefficient 26.64% ACoS. Today: €375,590 revenue at only 8.17% ACoS – a 69% efficiency improvement.',
    case3Client: 'Supplements Brand',
    case3Subtitle: 'Confidential Client',
    case3Badge: 'Cold Start',
    case3Highlight: '€112,628 revenue in 3 months, +45.9% profit',
    case3Desc: 'The client had never run Amazon Ads before and was skeptical of agencies. In one of the most competitive markets, we achieved over €112,000 in ad revenue at 11.94% ACoS in just 3 months.',
    case4Client: 'Electronics Manufacturer',
    case4Subtitle: 'Confidential Client',
    case4Badge: '+€24,543',
    case4Highlight: '-€16,542 → +€8,001 profit per quarter',
    case4Desc: 'The account was deep in the red. Within a few months, we achieved the turnaround and established consistent profitability.',
    case5Client: 'Home Appliances Brand',
    case5Subtitle: 'Confidential Client',
    case5Badge: '+€41,625',
    case5Highlight: '-€10,943 → +€30,682 profit (Jan-Sept)',
    case5Desc: 'Complete realignment of PPC strategy with focus on profitability over pure revenue growth.',
    changePortfolio: 'Portfolio restructuring',
    changeNegativeKW: 'Negative keyword harvesting',
    changeConversion: 'Conversion-based campaigns',
    changeRetargeting: 'Retargeting strategy',
    changeLaunch: 'Product launch support',
    changeListing: 'Listing optimization',
    changePortfolioNew: 'Portfolio built from scratch',
    changeTopPerformer: 'Focus on top performers',
  },

  testimonials: {
    title: 'What Our',
    titleHighlight: 'Clients Say',
    subtitle: 'Learn how we help sellers succeed on Amazon',
    readMore: 'Read more',
    readLess: 'Less',
    prevLabel: 'Previous testimonial',
    nextLabel: 'Next testimonial',
    trustCount: '50+',
    trustLabel: 'Happy Clients',
    trustRating: '5.0',
    trustRatingLabel: 'Average Google Rating',
    trustRecommend: '100%',
    trustRecommendLabel: 'Recommendation Rate',
    testimonial1: 'Since 2024, we\'ve trusted Fox Performance with our Amazon advertising. Wolfgang and Michael have not only optimized our campaigns but truly understand as strategic partners what matters for Papierdrachen. The collaboration is personal, transparent, and above all successful. We look forward to many more years together!',
    testimonial2: 'Working with Fox Performance has only advantages. Here I don\'t find an agency that just works on its own without transparency – instead, we discuss many important things directly with my personal contact. The last two products we launched on Amazon were profitable within just a few weeks.',
    testimonial3: 'With my brand Green Naturals, it\'s important to always get the maximum out of all channels – especially in such competitive product niches. Fox Performance stands out with fast communication and is a great help that is always reliable and thinks beyond the obvious.',
    testimonial4: 'Through Fox Performance, my products became truly visible on Amazon for the first time. What stands out is that the focus is on profit rather than just revenue. This gave me a good feeling from the start, and I wasn\'t disappointed.',
    testimonial5: 'We\'ve been working with Fox Performance for several years. Both in advertising and in images, the work is excellent. They think along, bring their own ideas and experience. It\'s not the typical \'agency-client relationship\' but a true partnership as it should be. I can absolutely recommend FOX PERFORMANCE.',
    testimonial6: 'Wolfgang from Fox Performance sees Amazon PPC through the seller\'s lens, just with more expertise. Clear statements, no typical agency talk! The man knows what he\'s talking about.',
    testimonial7: 'Wolfgang has a deep understanding of data-driven PPC management and leads his team with a clear vision and high standards. Under his leadership, he and his team managed to significantly reduce the TACoS of our Amazon account within a few months, thereby substantially increasing our company\'s profitability. He places great value on transparent processes and open exchange. Anyone looking for a partner who not only delivers expertise but creates real value while focusing on personal support is in the best hands with Wolfgang and his team at Fox Performance.',
    testimonial8: 'Reliable, fast, proactive. Exactly what you need to successfully launch on Amazon. Thanks to the Fox Performance team!',
    testimonial9: 'The deep PPC knowledge is immediately apparent in calls with Fox Performance, and he still manages to break down complex topics in an understandable way. Brutally honest and transparent!',
    testimonial10: 'We\'ve been working with Wolfgang and Michael for over 4 years now. The work with the Fox Performance team is always very goal-oriented and on equal footing. It\'s constantly about scaling and optimally developing our performance on Amazon. I think it\'s great that the team constantly evolves and reacts to the massive changes on Amazon to achieve optimal results for their clients. Keep it up!',
    role_kunde: 'Client',
    role_fbaSeller: 'FBA Seller',
    role_ceo: 'CEO',
    role_gruender: 'Founder',
    role_geschaeftsfuehrer: 'Managing Director',
  },

  featuredTestimonials: {
    testimonial1: 'Wolfgang has a deep understanding of data-driven PPC management and leads his team with a clear vision and high standards. Under his leadership, he and his team managed to significantly reduce the TACoS of our Amazon account within a few months, thereby substantially increasing our company\'s profitability.',
    testimonial2: 'The deep PPC knowledge is immediately apparent in calls with Fox Performance, and he still manages to break down complex topics in an understandable way. Brutally honest and transparent!',
    testimonial3: 'We\'ve been working with Wolfgang and Michael for over 4 years now. The work with the Fox Performance team is always very goal-oriented and on equal footing. It\'s constantly about scaling and optimally developing our performance on Amazon.',
    testimonial4: 'Since 2024, we\'ve trusted Fox Performance with our Amazon advertising. Wolfgang and Michael have not only optimized our campaigns but truly understand as strategic partners what matters for Papierdrachen. The collaboration is personal, transparent, and above all successful. We look forward to many more years together!',
  },

  teamSection: {
    label: 'Why Fox Performance?',
    title: 'Achieve Bestseller Status with',
    titleHighlight: 'Fox Performance',
    subtitle: 'Let us successfully scale your products on Amazon',
    teamImageAlt: 'Team - Wolfgang Niedecken and Michael Wenger',
    feature1Title: 'Over 15 Years of Amazon Expertise',
    feature1Subtitle: 'Proven strategies from thousands of campaigns',
    feature1Desc: 'Our team combines years of experience in the Amazon ecosystem. We have successfully scaled products in nearly every category and know the nuances that make the difference between average and bestseller.',
    feature2Title: 'Individual Growth Strategies',
    feature2Subtitle: 'Tailored to your products & goals',
    feature2Desc: 'No copy-paste solutions. We analyze your products, margins, and competition to develop a strategy tailored exactly to your business. From launch to scaling.',
    feature3Title: 'Personal Contact Person',
    feature3Subtitle: 'Direct line to your account manager',
    feature3Desc: 'You have a dedicated contact person who knows your business. Regular calls, transparent reports, and fast response times. No agency chaos, just partnership-driven collaboration.',
    feature4Title: 'Data-Driven Optimization',
    feature4Subtitle: 'Decisions based on real numbers',
    feature4Desc: 'We don\'t make gut decisions. Every optimization is based on detailed analysis of your performance data. TACoS, ACoS, CVR – we keep all KPIs in sight and optimize continuously.',
    cta: 'Free Account Analysis',
  },

  faq: {
    label: 'FAQ',
    title: 'Frequently Asked',
    titleHighlight: 'Questions',
    q1: 'What can advertising really do for me? I can\'t imagine it being such a big added value.',
    a1: 'Everyone has different search habits. Take the word "roll" – depending on the region you might say roll, bun, bread roll, etc. The same applies to products. Advertising is about presenting your products under the words your potential customers actually search for. The rule is simple: more visibility equals more revenue.',
    q2: 'We handle this in-house and it\'s going quite well. Why should I involve someone external?',
    a2: 'It\'s great that you\'ve recognized the importance of this topic. You\'re already well ahead of many sellers. With most companies I speak to that handle this in-house, it\'s not about explaining the basics, but rather the structure behind advertising, the interplay of ad formats, new opportunities in advertising, optimization routines, and the right strategies for each product. These are things you can\'t learn from a textbook, and if everything were running perfectly, you wouldn\'t have caught our analyst\'s attention and we wouldn\'t be talking now. Whether I can actually help you – that\'s for the data to decide.',
    q3: 'Our margins on the product are so low that it doesn\'t make sense to run ads on top of that.',
    a3: 'That\'s exactly why it\'s even more important to have your advertising perfectly aligned. There\'s the right strategy for every product, and we just need to see how much potential your products still have.',
    q4: 'I\'ve had bad experiences with other agencies and we want to handle it ourselves now.',
    a4: 'Then it\'s great that we\'re talking. Let us convince you otherwise and approach this topic in a completely transparent and data-driven way. If after my analysis I find that you already have everything under control, I\'ll tell you exactly that. But if I see major improvements, I\'ll show you where they are – and then you can decide for yourself.',
    q5: 'I only sell third-party products (Buybox).',
    a5: 'Whether it\'s Buybox products or private labels, you need visibility in any case these days. Especially when, like you, you have a high Buybox share.',
    q6: 'How much time do I need as an Amazon Seller per month once I start?',
    a6: 'At the beginning of our collaboration, we plan about 1-2 hours for onboarding and initial alignment. After that, you only need about 1 hour per month during ongoing operations – we handle the rest.',
  },

  footer: {
    logoText: 'Fox Performance',
    copyright: 'Amazon PPC & Product Images',
    quickLinksTitle: 'Quick Links',
    quickLink_ppc: 'Amazon PPC',
    quickLink_images: 'Product Images',
    quickLink_portfolio: 'Portfolio',
    quickLink_references: 'References',
    quickLink_about: 'About Us',
    quickLink_faq: 'FAQ',
    supportTitle: 'Support',
    support_contact: 'Contact',
    support_booking: 'Book a Meeting',
    support_linkedin: 'LinkedIn',
    support_instagram: 'Instagram',
    legalTitle: 'Legal',
    legal_imprint: 'Imprint',
    legal_privacy: 'Privacy Policy',
    legal_terms: 'Terms & Conditions',
    legal_cookies: 'Cookie Settings',
  },

  portfolioPage: {
    backToHome: 'Back to Homepage',
  },

  imageGallery: {
    label: 'Selected Projects',
    title: 'Design',
    titleHighlight: 'Portfolio',
    imagesFrom: 'images from',
    projects: 'projects',
    filterAll: 'All',
    showAll: 'Show All Images',
    loadMore: 'Load More',
    moreImages: 'more',
    close: 'Close',
    imageAlt: 'Image',
    categories: {
      alpinspirit: 'Outdoor & Sport',
      aquaone: 'Aquatics',
      'bb-verpackungen': 'Packaging',
      boomding: 'Electronics',
      buxtrade: 'Food & Snacks',
      cartvelli: 'Kitchen',
      graefenhof: 'Tea & Herbs',
      greenli: 'Kitchen & Household',
      mcfilter: 'Household',
      oswald: 'Food & Spices',
      papierdrachen: 'Crafts & DIY',
      yosana: 'Kitchen & Lifestyle',
    },
  },

  processPricing: {
    processLabel: 'It\'s That Easy',
    processTitle: 'How It Works',
    processSubtitle: 'Get your product images in 3 steps.',
    step1Number: 'Step 1',
    step1Title: 'Quick Briefing',
    step1Time: '5 min',
    step1Text: 'Send us your product photos and the Amazon link. We analyze the reviews and get started.',
    step1Feature1: 'Basic photos of your product',
    step1Feature2: 'Amazon link (yours or competitor)',
    step1Feature3: 'No photos? Send us the product',
    step1Link: 'Start Briefing Now',
    step2Number: 'Step 2',
    step2Title: 'We Create Your Images',
    step2Badge: 'Fast Turnaround',
    step2Text: 'We create your images – based on real reviews, conversion-optimized.',
    step2Feature1: 'Main image per Amazon TOS',
    step2Feature2: 'Infographics & Lifestyle',
    step2Feature3: 'Review-based',
    step3Number: 'Step 3',
    step3Title: 'Revision & Finalization',
    step3Badge: 'Ready for Amazon',
    step3Text: 'You receive your images, give feedback – one revision is included, more available at extra cost.',
    step3Feature1: 'All formats (JPG, PNG)',
    step3Feature2: '1 revision included',
    step3Feature3: 'Additional revisions at extra cost',
    step3Feature4: 'Full usage rights included',
    pricingLabel: 'Our Offers',
    pricingHeadline: 'Start for free or get the',
    pricingHeadlineHighlight: 'complete package',
    freeBadge: 'Free',
    freeTitle: 'A/B Test Image',
    freeSubtitle: 'Try us with no commitment',
    freePrice: '€0',
    freePeriod: 'one-time',
    freeDesc: 'We create an optimized product image for your Amazon account – completely free. Compare it with your current image and see the difference.',
    freeFeature1: '1 optimized product image',
    freeFeature2: 'Based on review analysis',
    freeFeature3: 'Perfect for A/B tests',
    freeFeature4: 'No commitment & risk-free',
    freeCta: 'Request Free Image',
    paidBadge: 'Recommended',
    paidTitle: 'Image Package',
    paidSubtitle: 'Complete Listing Set',
    paidPricePrefix: 'from',
    paidPrice: '€999',
    paidPeriod: 'per product',
    paidDesc: 'The complete package for your Amazon listing: All the images you need – main image, infographics, lifestyle shots, and A+ content.',
    paidFeature1: 'Up to 10 product images',
    paidFeature2: 'Main image + gallery',
    paidFeature3: 'Infographics & Lifestyle',
    paidFeature4: 'A+ Content ready',
    paidFeature5: '1 revision loop incl.',
    paidFeature6: 'Full usage rights',
    paidCta: 'Request Image Package',
  },

  guidePage: {
    back: 'Back to Homepage',
    title: 'Download your',
    titleHighlight: 'Low Bid Guide',
    titleEnd: 'now',
    subtitle: 'Learn how the right bidding strategy can make your Amazon Ads more profitable – free and with no strings attached.',
    labelCompany: 'Company',
    labelName: 'Full Name',
    labelEmail: 'Your Email Address',
    labelPhone: 'Phone Number',
    placeholderCompany: 'Seller Syndicate GmbH',
    placeholderName: 'Max Mustermann',
    placeholderEmail: 'e.g. max@mustermann.de',
    placeholderPhone: 'e.g. 0176 1234 567',
    privacyText: 'I confirm that I have read and accept the',
    privacyLink: 'Privacy Policy',
    privacyEnd: '.',
    submit: 'Download Low Bid Guide',
    submitting: 'Sending...',
    secureNote: 'Your data is safe with us!',
    successTitle: 'Download incoming!',
    successText: 'Thank you! We will send you the guide via email shortly.',
    successBack: 'Back to Homepage',
    errorText: 'Something went wrong. Please try again.',
  },

  mastermindPage: {
    guestLabel: 'Our Next Guest',
    back: 'Back to Homepage',
    title: 'Apply for the',
    titleBreak: true,
    titleHighlight: 'Seller Syndicate Mastermind',
    subtitle: 'Apply now for our exclusive mastermind group and take your Amazon business to the next level.',
    labelCompany: 'Company',
    labelName: 'Full Name',
    labelEmail: 'Your Email Address',
    labelPhone: 'Phone Number',
    placeholderCompany: 'Seller Syndicate GmbH',
    placeholderName: 'Max Mustermann',
    placeholderEmail: 'e.g. max@mustermann.de',
    placeholderPhone: 'e.g. 0176 1234 567',
    privacyText: 'I confirm that I have read and accept the',
    privacyLink: 'Privacy Policy',
    privacyEnd: '.',
    submit: 'Apply Now',
    submitting: 'Sending...',
    secureNote: 'Your data is safe with us!',
    successTitle: 'Application received!',
    successText: 'Thank you for your application. We will get back to you shortly.',
    successBack: 'Back to Homepage',
    errorText: 'Something went wrong. Please try again.',
  },

  common: {
    loading: 'Loading...',
  },
};

export default en;
